import styled from 'styled-components';

const ContenedorSinFactor = styled.div`
.contenedor-informacion {
    background-color: #F1E6AB;
    padding: 14px;
    margin: 0 23px;
    display: flex;
    align-items: flex-start;
  }
  .contenedor-informacion p {
    color: #967100;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
}
p.strong {
  font-size: 13px !important;
  font-weight: bold;
}

.descargar-app {
  margin: 0 23px;
}
.descargar-app p {
  color: #333333;
  font-size: 14px;
  text-align: center;
  font-weight: 400;
}
.contenedor-informacion p strong {
  font-size: 12px;
}
hgroup.split h2 {
  color: #333333;
  font-size: 16px;
  font-weight: 400;
} 
hgroup.split p {
  color: #333333;
  font-size: 13px;
  line-height: 15px;
  font-weight: 400;
  text-align: left;
}
.descargar-app figure {
  margin: 57px;
  margin-bottom: 10px;
  margin-top: 36px;
}

figure.btn-apps {
  display: flex;
  margin-top: 12px !important;
  justify-content: space-around;
  padding-bottom: 45px;
}

figure.btn-apps img {
  width: 45%;
}
.contenedor-informacion img {
  filter: inherit;
  margin-right: 10px;
}

@media (max-width: 427px){

    .contenedor-informacion p{
      line-height: 15px;
    }
    hgroup.split h2 {
      font-size: 14px;
    }
    hgroup.split p {
      font-size: 11px;
    }
    .descargar-app figure {
      margin: 27px 60px 0 60px;
    }
    .contenedor-error {
      margin-top: 16px;
    }
    
  }

@media (max-width: 376px){
  .contenedor-informacion p{
    font-size: 11px;
  }
  hgroup.split h2 {
    font-size: 14px;
  }
  hgroup.split p {
    font-size: 11px;
  }
  .descargar-app figure {
    margin: 27px 35px 0 35px;
  }
  .contenedor-error {
    margin-top: 16px;
  }

}

@media (max-width: 321px){
  .contenedor-informacion p{
    font-size: 11px;
  }
  hgroup.split h2 {
    font-size: 13px;
  }
  hgroup.split p {
    font-size: 10px;
  }
  .descargar-app figure {
    margin: 28px;
    margin-bottom: 0;
  }
  .contenedor-error {
    margin-top: 16px;
  }
  .descargar-app p {
    font-size: 11px !important;
}
}
`;

export default ContenedorSinFactor;